import { render, staticRenderFns } from "./TriggerForm.vue?vue&type=template&id=f2ff4d34&scoped=true&"
import script from "./TriggerForm.vue?vue&type=script&lang=js&"
export * from "./TriggerForm.vue?vue&type=script&lang=js&"
import style0 from "./TriggerForm.vue?vue&type=style&index=0&id=f2ff4d34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ff4d34",
  null
  
)

export default component.exports